import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import styled from 'styled-components'

export const AiGenerationLoadingContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  position: relative;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    gap: 24px;
  }
`

export const GenerateLoadingLabelWrapper = styled.div<{ $overlay: boolean }>`
  padding-inline: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  position: ${props => (props.$overlay ? 'absolute' : 'relative')};
`

export const LoadingStateWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`
